import Util from '../services/util/-RFC.util.js';

let me;
const observableMe = new Rx.BehaviorSubject(me);

/**
     * @ngdoc service
     * @name repositories.MeRepository
     *
     * @description
     * MeRepository.
     */
const MeRepository = {

    /**
         * @ngdoc function
         * @name repositories.MeRepository#replace
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored users with provided data.
         *
         * @param {object} data, current logged user.
        */
    replace(data) {

        me = data;
        observableMe.onNext(me);

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#update
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to update the current logged user from repository.
         *
         * @param {object} data, object with new values.
        */
    update(data) {

        me = me || {};
        me.data = data;
        observableMe.onNext(me);

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyUser
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user from repository.
         *
         * @returns {object} current logged user data.
        */
    getMyUser() {

        return Util.deepFind(me, 'data');

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyId
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user id from repository.
         *
         * @returns {number} current logged user id.
        */
    getMyId() {

        return Util.deepFind(me, 'data.id');

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyEmail
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user email from repository.
         *
         * @returns {string} current logged user email.
        */
    getMyEmail() {

        return Util.deepFind(me, 'data.attributes.email');

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyaUrl
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive Mya Url from repository.
         *
         * @returns {string} MyaURL
        */
    getMyaUrl() {

        return Util.deepFind(me, 'meta.mya_url');

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyaHash
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive Mya Hash from repository.
         *
         * @returns {string} MyaHash
        */
    getMyaHash() {

        return Util.deepFind(me, 'meta.mya_hash');

    },

    /**
         * @ngdoc function
         * @name repositories.MeRepository#getObservable
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for me repository.
         * @returns {Object} an observable object for me repository.
        */
    getObservable() {

        return observableMe;

    },

};


export default MeRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.meRepository.js